import React from "react";
import SideMenuBar from "../Dashboard/SideMenubar";
import { Outlet, useLocation } from "react-router-dom";
import UploderClosinWarning from "../UploaderClosingWarning";
import FileUpload from "../FileUploadComponent/FileUpload";
import FPAFileUpload from "../FPAFileUploadComponent/FPAFileUpload";

const DashboardComponent = ({ isCollapsed, setIsCollapsed }) => {
  const location = useLocation();

  return (
    <>
      {location.pathname.indexOf("payment") === -1 && (
        <SideMenuBar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
      )}
      <Outlet context={[isCollapsed]} />

      <FileUpload />
      <FPAFileUpload />
    </>
  );
};

export default DashboardComponent;
